<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div v-if="errMessage" class="center">
    <van-empty :description="errMessage" />
  </div>
  <div v-else class="ml15 mr15">
    <img class="width100 mb20 contain BGf0" :onerror="imgError" :src="detail.image" alt="">
  </div>
  <div @click="$router.push({ path:'/feedback',query:{column_type:5,common_id:$route.query.id,cate_id:$route.query.cate_id }})" class="fixed l b mb80 Cfff" 
  style="border-radius:0 20px 20px 0;padding:10px 18px;background:rgba(8,109,143,.45)">意见反馈</div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
      errMessage:null,
      detail:{}
    }
  },
  watch:{
  },
  methods:{
    netx() {
      history.forward()
    }
    // next(){
    //   if(this.detail.is_deliver){
    //     return this.$router.back()
    //   }
    //   if(this.detail.is_concept==0){
    //     this.$router.push({path:'/join/sense',query:{...this.$route.query}})
    //   }else{
    //     this.$router.push({path:'/join/edit',query:{...this.$route.query}})
    //   }
    // }
  },
  created(){
    this.ajax.post("joins/getinfo",{...this.$route.query}).catch(({data})=>{
      let {message} = data;
      this.errMessage = message
    }).then(({data})=>{
      this.detail = data;
    })
  }
}
</script>

<style>
</style>
